<template>
  <span>{{ roundedCount }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  count: number | string | undefined;
}>();

const roundedCount = computed(() => {
  const count = Number(props.count) || 0;
  const rounded = Math.floor(count / 10) * 10;
  return `${rounded}+`;
});
</script>
